import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { EmployeeModel } from '../../../../../../shared/store/employee/types';
import { EmployeeService } from '../../../../../../shared/store/employee/employee.service';

@Component({
    selector: 'app-employee-details-private-informations',
    templateUrl: './employee-details-private-informations.component.html',
    styleUrls: ['./employee-details-private-informations.component.scss'],
    standalone: false
})
export class EmployeeDetailsPrivateInformationsComponent {
  employeeDetail$: Observable<EmployeeModel>;

  constructor(private readonly employeeService: EmployeeService) {
    this.employeeDetail$ = this.employeeService.getById.value$;
  }
}
